import { useState, useEffect } from 'react';
import shuffle from 'lodash.shuffle';
import './style.css'
import ConfettiExplosion from 'react-confetti-explosion';

export default function FindPair({ data }) {
    const habitats = data.map(item => item.elem2);
    const [animalOptions, setAnimalOptions] = useState([]);
    const [habitatOptions, setHabitatOptions] = useState([]);
    const [draggingAnimal, setDraggingAnimal] = useState(null);
    const [matches, setMatches] = useState({});
    const [attempt, setAttempt] = useState(0);
    const [score, setScore] = useState(0);
    const [totalScore, setTotalScore] = useState(0);
    const [showConfetti, setShowConfetti] = useState(false);
    const [shake, setShake] = useState(false);

    useEffect(() => {
        startNewGame();
    }, []);

    const startNewGame = () => {
        setAnimalOptions(shuffle(data));
        setHabitatOptions(shuffle(habitats));
        setMatches({});
        setAttempt(0);
        setScore(0);
    };

    const handleDragStart = (animal) => {
        setDraggingAnimal(animal);
    };

    const handleDrop = (habitat) => {
        if (!draggingAnimal) return;

        setMatches(prev => ({ ...prev, [draggingAnimal.elem1]: habitat }));
        setDraggingAnimal(null);
    };

    const checkAnswer = () => {
        let correctCount = 0;
        animalOptions.forEach(animal => {
            if (matches[animal.elem1] === animal.elem2) {
                correctCount++;
            }
        });

        if (correctCount === data.length) {
            const gained = attempt === 0 ? 10 : 5;
            setScore(gained);
            setTotalScore(prev => prev + gained);
            setShowConfetti(true);
            setTimeout(() => setShowConfetti(false), 8000);
        } else {
            setAttempt(prev => prev + 1);
            setShake(true);
            setTimeout(() => setShake(false), 1000);
        }
    };

    const resetGame = () => {
        startNewGame();
        setTotalScore(0);
    };

    return (
        <div className="text-center mt-4">
            <div className="row">
                <div className="col-12 mb-4">
                    <h3 className="mb-4 text-white">O'xshash elementlarni birlashtiring.</h3>
                    <hr />
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-6">
                            <div className="row">
                                {animalOptions.map((animal, idx) => (
                                    !matches[animal.elem1] && (
                                        <div
                                            key={idx}
                                            className="col-6"
                                        >
                                            <img
                                                src={animal.image1}
                                                alt={animal.alem1}
                                                draggable
                                                onDragStart={() => handleDragStart(animal)}
                                                style={{ height: '150px', margin: '10px', cursor: 'grab' }}
                                                className="img-fluid bg-light bg-gradient rounded p-3 rounded-circle"
                                            />
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>

                        <div className="col-12 col-lg-6">
                            <div className="row">
                                {habitatOptions.map((habitat, idx) => {
                                    const matchingAnimal = data.find(animal => animal?.elem2 === habitat);
                                    return (
                                        <div
                                            key={idx}
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={() => handleDrop(habitat)}
                                            className={`col-6 p-3 ${shake ? 'shake' : ''}`}
                                        >
                                            <div className='p-2 rounded' style={{ height: '300px', background: '#F3EBFF', fontSize: '18px', fontWeight: '700' }}>
                                                <div>{habitat}</div>
                                                <div>
                                                    {matchingAnimal && (
                                                        <img
                                                            src={matchingAnimal?.image2}
                                                            alt={habitat}
                                                            style={{ width: '100%', height: '150px', objectFit: 'contain' }}
                                                            className="img-fluid rounded"
                                                        />
                                                    )}
                                                </div>
                                                <div
                                                    className="mt-1 rounded text-white d-flex justify-content-center align-items-center"
                                                    style={{ height: '100px', background: '#F3EBFF', fontSize: '18px', border: '1px dashed #704FE6' }}
                                                >
                                                    {Object.keys(matches).find(animalName => matches[animalName] === habitat)
                                                        ?
                                                        <img
                                                            src={animalOptions.find(animal => animal.elem1 === Object.keys(matches).find(animalName => matches[animalName] === habitat))?.image1}
                                                            alt={Object.keys(matches).find(animalName => matches[animalName] === habitat)}
                                                            style={{ maxHeight: '100px', cursor: 'grab' }}
                                                            className="img-fluid py-2"
                                                        />
                                                        :
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-plus-circle-dotted text-secondary opacity-25" viewBox="0 0 16 16">
                                                            <path d="M8 0q-.264 0-.523.017l.064.998a7 7 0 0 1 .918 0l.064-.998A8 8 0 0 0 8 0M6.44.152q-.52.104-1.012.27l.321.948q.43-.147.884-.237L6.44.153zm4.132.271a8 8 0 0 0-1.011-.27l-.194.98q.453.09.884.237zm1.873.925a8 8 0 0 0-.906-.524l-.443.896q.413.205.793.459zM4.46.824q-.471.233-.905.524l.556.83a7 7 0 0 1 .793-.458zM2.725 1.985q-.394.346-.74.74l.752.66q.303-.345.648-.648zm11.29.74a8 8 0 0 0-.74-.74l-.66.752q.346.303.648.648zm1.161 1.735a8 8 0 0 0-.524-.905l-.83.556q.254.38.458.793l.896-.443zM1.348 3.555q-.292.433-.524.906l.896.443q.205-.413.459-.793zM.423 5.428a8 8 0 0 0-.27 1.011l.98.194q.09-.453.237-.884zM15.848 6.44a8 8 0 0 0-.27-1.012l-.948.321q.147.43.237.884zM.017 7.477a8 8 0 0 0 0 1.046l.998-.064a7 7 0 0 1 0-.918zM16 8a8 8 0 0 0-.017-.523l-.998.064a7 7 0 0 1 0 .918l.998.064A8 8 0 0 0 16 8M.152 9.56q.104.52.27 1.012l.948-.321a7 7 0 0 1-.237-.884l-.98.194zm15.425 1.012q.168-.493.27-1.011l-.98-.194q-.09.453-.237.884zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a7 7 0 0 1-.458-.793zm13.828.905q.292-.434.524-.906l-.896-.443q-.205.413-.459.793zm-12.667.83q.346.394.74.74l.66-.752a7 7 0 0 1-.648-.648zm11.29.74q.394-.346.74-.74l-.752-.66q-.302.346-.648.648zm-1.735 1.161q.471-.233.905-.524l-.556-.83a7 7 0 0 1-.793.458zm-7.985-.524q.434.292.906.524l.443-.896a7 7 0 0 1-.793-.459zm1.873.925q.493.168 1.011.27l.194-.98a7 7 0 0 1-.884-.237zm4.132.271a8 8 0 0 0 1.012-.27l-.321-.948a7 7 0 0 1-.884.237l.194.98zm-2.083.135a8 8 0 0 0 1.046 0l-.064-.998a7 7 0 0 1-.918 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                                                        </svg>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="mt-4 text-white">
                        <p>Urinishlar: <strong className='accent-color fs-5'>{attempt}</strong></p>
                        <hr />
                        <p>Ushbu o‘yindan olingan ball: <strong className='accent-color fs-5'>{score}</strong></p>
                    </div>
                    <div className="d-flex gap-4 mb-4 justify-content-center">
                        <button
                            onClick={checkAnswer}
                            className="btn btn-primary btn-lg"
                            data-discover="true"
                        >
                            <span>
                                Tekshirish
                                {showConfetti && <ConfettiExplosion options={{
                                    force: 1.5,
                                    duration: 5000,
                                    particleCount: 400,
                                    floorHeight: 1600,
                                    floorWidth: 1600
                                }}
                                />}
                            </span>
                        </button>
                        <button
                            onClick={resetGame}
                            className="btn btn-danger btn-lg"
                            data-discover="true"
                        >
                            <span>
                                Qayta boshlash
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
